import { render, staticRenderFns } from "./ExpiryManagement.vue?vue&type=template&id=7ebccc58&scoped=true"
import script from "./ExpiryManagement.vue?vue&type=script&lang=js"
export * from "./ExpiryManagement.vue?vue&type=script&lang=js"
import style0 from "./ExpiryManagement.vue?vue&type=style&index=0&id=7ebccc58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebccc58",
  null
  
)

export default component.exports